import { QnaItem } from 'components/VisualSearch/VisualSearchResults/visualSearchResults.types';

export const TROUBLESHOOT_HELP_HEADER = 'Troubleshooting Help';

export const TROUBLESHOOT_QNA_RECOGNIZE_ALL_PIECES: QnaItem = {
  question: 'Why does Search By Photo not recognize all pieces in the photo?',
  answer:
    'Search By Photo currently supports clothing and shoes. Search By Photo does not work on handbags, accessories, kids or maternity clothing.'
};

export const TROUBLESHOOT_QNA_INCORRECT_RESULTS: QnaItem = {
  question: 'I don’t get the results I was looking for. What might be going on?',
  answer:
    'Make sure the photo you use captures the entire item you are looking for. We’re continuously striving to provide you with a better experience. If it’s still not working, you may be looking for an item that is currently not supported by Search By Photo.'
};

export const TROUBLESHOOT_QNA_NO_RESULTS: QnaItem = {
  question: 'Why am I getting a network error?',
  answer:
    'Search By Photo needs an internet connection (over wifi or data network) to search. If you can’t access the internet right now, you will get a network error message. Check your network settings and try again.'
};

export const PHOTO_ZOOM_IN = 'Photo Zoom In';
export const PHOTO_ZOOM_OUT = 'Photo Zoom Out';

export const MAX_ALLOWED_IMAGE_SIZE_BYTES = 10485760; // 10 * 1024 * 1024
